export default "__VITE_PUBLIC_ASSET__d9b1189d__"